// extracted by mini-css-extract-plugin
module.exports = {"InfoItem":"PlayerInfoItem_InfoItem__2Kimw","Label":"PlayerInfoItem_Label__dQlvU","Value":"PlayerInfoItem_Value__1nUjQ"};